import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState } from '../store/store';

export const setDisableEmptyReadingPaneFillMutator: (
    targetWindow: Window,
    disable: boolean
) => void = mutatorAction(
    'setDisableEmptyReadingPaneFillMutator',
    (targetWindow: Window, disable: boolean): void => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.disableEmptyReadingPaneFill = disable;
    }
);
